import { Accessor, For } from "solid-js";
import { Col, Grid } from "~/components/ui/grid";
import { PostCard } from "../Card";
import { Post } from "../../types/post";

interface Props {
	posts: Accessor<Post[]>;
	onClickPost?: (id: string) => void;
}

export function PostGrid(props: Props) {

	return (
		<Grid
			class="gap-4"
			cols={1}
			colsMd={2}
			colsLg={3}
		>
			<For each={props.posts()}>
				{post => (
					<Col>
						<PostCard post={post} onClickPost={props.onClickPost} />
					</Col>
				)}
			</For>
		</Grid>
	);
}